import Insured from '@/modules/common/common/models/APP/Insured'
import { UserRoleEnum } from '../models/enums'
import { format } from '@/utils/date.utils'
import type { OptionsValuesInterface } from '../models/types'

export function useSummaryComposable(t: any) {
  function getDocumentInsuredStep(insured: Insured) {
    const { documentDetails: document } = insured
    const isMinor = document.documentType === 'MENOR'
    const hasDocumentNumber = !!document.documentNumber

    const isVisible = hasDocumentNumber || isMinor

    const value = isMinor ? document.documentTypeText : document.documentNumber
    return {
      label: t('hiring.summary.health.step2.items.0.label'),
      visible: isVisible,
      value
    }
  }

  function getPolicyNumberStep(insured: Insured) {
    return {
      label: t('Nº Póliza'),
      visible: !!insured.healthPolicyNumber,
      value: insured.healthPolicyNumber!
    }
  }

  function getAddressStep(insured: Insured) {
    return {
      label: t('hiring.summary.health.step2.items.1.label'),
      visible: !!insured.addressDetails.postalCode,
      value: insured.addressDetails.getCompleteAddress()
    }
  }

  function getBirthDateStep(insured: Insured) {
    return {
      label: t('hiring.summary.health.step2.items.4.label'),
      visible: !!insured.userDetails.birthDate,
      value: insured.userDetails.birthDate ? format(insured.userDetails.birthDate) : ''
    }
  }

  function getGenderStep(insured: Insured, genders: OptionsValuesInterface[]) {
    return {
      label: t('hiring.summary.health.step2.items.5.label'),
      visible: !!insured.userDetails.gender,
      value: getGenderLabel(insured.userDetails.gender, genders)
    }
  }
  function getEmailStep(insured: Insured) {
    return {
      label: t('hiring.summary.health.step2.items.2.label'),
      visible: !!insured.userDetails.email,
      value: insured.userDetails.email
    }
  }

  function getPhoneStep(insured: Insured) {
    return {
      label: t('hiring.summary.health.step2.items.3.label'),
      visible: !!insured.userDetails.phone,
      value: insured.userDetails.getCompletePhone()
    }
  }

  function filterInsuredsRenderableSteps(
    insured: Insured,
    currentRiskNumber: number,
    steps: any[],
    subStepIndex?: number
  ) {
    const currentUserIsHolder = insured.role === UserRoleEnum.HOLDER_NOT_INSURED
    const isShowingCurrentInsured = currentRiskNumber === insured.riskNumber
    const insuredRiskNumberIsHigher = insured.riskNumber > currentRiskNumber

    let index = 0
    if (isShowingCurrentInsured) {
      index = typeof subStepIndex === 'number' ? subStepIndex : steps.length!
    } else if (insuredRiskNumberIsHigher && !currentUserIsHolder) {
      index = 0
    } else {
      index = steps.length
    }

    return steps.splice(0, index).flat()
  }

  function getGenderLabel(gender: string | null, genderOptions: OptionsValuesInterface[]) {
    if (!gender) return
    return genderOptions.find((elm) => elm.value === gender)?.label
  }

  return {
    getDocumentInsuredStep,
    getPolicyNumberStep,
    getAddressStep,
    getBirthDateStep,
    getGenderStep,
    getEmailStep,
    getPhoneStep,
    filterInsuredsRenderableSteps
  }
}
